exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-schedule-span > span > span {\n  font-size: 1.5rem;\n}", ""]);

// exports
